
//Gform main function
export default function () {

    let $gfield = document.querySelectorAll('.gfield');
    

    //Gform behaviour
    gfield_events($gfield);
    gfield_defaults($gfield);
}


/**
 * Focus event for gravity form field components
 * 
 * 
 * @param {HTMLAllCollection} $gfield 
 */
const gfield_events = ( $gfield ) => {
    
    $gfield.forEach( $field => {

        let $input = $field.querySelector('input, textarea');


        // Handles all events for input fields
        if( $input ) {
            $input.addEventListener( 'focus', () => {
                $field.classList.add('focus');
                
            });

            $input.addEventListener( 'blur', () => {
                $field.classList.remove('focus');
            });

            $input.addEventListener( 'input', () => {

                if( $input.value === '') {
                    $field.classList.remove('input');
                } else {
                    $field.classList.add('input');
                }
                
            });
        }
    });
} 

/**
 * Gravity form field component default behaviour
 * 
 * 
 * @param {HTMLAllCollection} $gfield 
 */
const gfield_defaults = ( $gfield ) => {

    $gfield.forEach( $field => {

        let $input = $field.querySelector('input, textarea');

        if( $input ) {
            
            if( $input.value !== '' ) {
                $field.classList.add('input');
            } else {
                $field.classList.remove('input');
            }
        }
    });
}